export default __webpack_public_path__ + "static/media/Delimiter.a252907e.svg";